// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"SectionTitle--next-sr-only--rLPUHH-","mainBox":"SectionTitle--mainBox--5bUwtBh","preface":"SectionTitle--preface--OnyDJCF","title":"SectionTitle--title--2v3ol4G"};